import React from 'react'
import NavHead from './NavHead.jsx'
import Homepage from './Homepage.jsx'
import About from './About.jsx'
import Social from './SocialMedia.jsx'
import ContactPage from "./Contact.js";
import Our from "./Our.js";
function Page() {
  return (
    < >
      <NavHead />
      <Homepage />
      <About />
      <Social />
      <ContactPage />
      <Our />
    </>
  );
}

export default Page;
